import axios from "axios"

export const getDefaultCurrency = () => {
    return axios.get("currencies/default");
}
